import { log, callAdminAjax, getSwiperMediaItems, getTemplate } from './utils.js';
import { singleStageShare_setupSwiper } from './plannerPage.js';

const $ = window.jQuery;

let directoryRootMediaGallery_inflightFetchMoreRequest = false;

let directoryRootMediaGallery_swiperInstance = null;
let singlePlace_servicesSwiper_swiperInstance = null;
let mapPopupSwiper_swiperInstance = null;

export function getSinglePlace_servicesSwiper_swiperInstance() {
    return singlePlace_servicesSwiper_swiperInstance;
}

export function getDirectoryRootMediaGallery_swiperInstance() {
    return directoryRootMediaGallery_swiperInstance;
}

export function getMapPopupSwiper_swiperInstance() {
    return mapPopupSwiper_swiperInstance;
}

export function nullMapPopupSwiper_swiperInstance() {
    mapPopupSwiper_swiperInstance = null;
}

export function initHulk() {
    initSwipersIn(document.body);
}

// ------------------------------------------------------------
// Swiper management functions.
// ------------------------------------------------------------
/**
 * Initialize Swiper instances in the given root element.
 * @param {Element} root - The root element to initialize Swiper instances in.
 * Use document.body as the root element to initialize Swiper instances in the entire document.
 */
export function initSwipersIn(root = document.body) {
    root.querySelectorAll('[data-swiper]').forEach((el) => {
        log('initSwipersIn: el', el);
        if (el.swiper) return;

        let dataSwiper = el.getAttribute('data-swiper');
        let contentType = el.getAttribute('data-swiper-content-type');

        let options = null;
        
        // Configure the Swiper options based on the data-swiper attribute.
        if(dataSwiper === 'singleStageShare' || dataSwiper === 'mapStyleSelect') {
            options = {
                loop: false,
                slidesPerView: 2,
                spaceBetween: 8,
                breakpoints: {
                    350: {
                        slidesPerView: 3,
                    },
                },
                navigation: {
                    prevEl: '.photo-image-prev',
                    nextEl: '.photo-image-next',
                },
            };
        } else if(dataSwiper === 'directoryGallery') {
            options = {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 16,
                navigation: {
                    prevEl: '.btn-prev',
                    nextEl: '.btn-next',
                },
            };
        } else if(dataSwiper === 'singlePlace_servicesSwiper') {
            log('singlePlace_servicesSwiper: initializing swiper instance');
            options = {
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: {
                    prevEl: '#prev',
                    nextEl: '#next',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                },
            };
        } else if(dataSwiper === 'hotelCardImageSwiper') {
            options = {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: {
                    prevEl: '.btn-prev',
                    nextEl: '.btn-next',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            };
        } else if(dataSwiper === 'mapPopupSwiper') {
            options = {
                loop: true,
                spaceBetween: 24,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    prevEl: ".btn-prev",
                    nextEl: ".btn-next",
                },
            };
        } else {
            options = dataSwiper ? JSON.parse(dataSwiper) : null;
            log('Swiper options', options);
        }
    
        // Initialize the Swiper instance (Swiper function is global).
        const swiperInstance = new Swiper(el, options);
        log('Swiper instance', swiperInstance);

        // Swiper-type specific POST-initialization setups.
        // (Specifically, set it up to fetch more items when the user is nearing the end of the swiper instance. Only for photos and videos)
        if(dataSwiper === 'singleStageShare') {
            if(contentType === 'photos' || contentType === 'videos') {
                singleStageShare_setupSwiper(el, swiperInstance);
            } else {
                log('Swiper content type is not photos or videos, skipping setup');
            }
        } else if(dataSwiper === 'directoryGallery') {
            // Save the swiper instance to the global variable so we can update it later when new slides are added.
            directoryRootMediaGallery_swiperInstance = swiperInstance;
            // Setup the swiper instance to fetch more items when the user is nearing the end of the swiper instance.
            directoryRootMediaGallery_setupSwiper(el, swiperInstance);
        } else if(dataSwiper === 'singlePlace_servicesSwiper') {
            // Save the swiper instance to the global variable so we can update it later when new slides are added.
            singlePlace_servicesSwiper_swiperInstance = swiperInstance;
        } else if(dataSwiper === 'mapPopupSwiper') {
            // Save the swiper instance to the global variable so we can update it later when new slides are added.
            mapPopupSwiper_swiperInstance = swiperInstance;
        }
    });
  
    // ensure correct sizing (modal just became visible)
    requestAnimationFrame(() => {
      root.querySelectorAll('[data-swiper]').forEach((el) => {
        el.swiper?.update();
      });
    });
}


/**
 * Destroy Swiper instances in the given root element.
 * @param {Element} root - The root element to destroy Swiper instances in.
 * Use document.body as the root element to destroy Swiper instances in the entire document.
 */
export function destroySwipersIn(root = document.body) {
    root.querySelectorAll('[data-swiper]').forEach((el) => {
        if (el.swiper) el.swiper.destroy(true, true);
    });
}

/**
 * Setup the directory root media gallery swiper instance AFTER it has been initialized.
 * Specifically, set it up to fetch more items when the user is nearing the end of the swiper instance.
 * @param {Element} el - The element to setup the swiper instance for.
 * @param {Swiper} swiperInstance - The swiper instance to setup.
 */
function directoryRootMediaGallery_setupSwiper(el, swiperInstance) {
    // Add the slide change event listener to the swiper instance to fetch more items when the user is nearing the end of the swiper instance.
    swiperInstance.on("slideChange", () => {
        log('directoryRootMediaGallery_swiperInstance: slideChange');
        log('swiperInstance', swiperInstance);

        const remaining = swiperInstance.slides.length - 1 - swiperInstance.activeIndex;
        log('directoryRootMediaGallery_swiperInstance: remaining', remaining);
        const PREFETCH_AHEAD = 3;

        if (remaining <= PREFETCH_AHEAD) {

            // First check if the global post media gallery has more items in it that weren't loaded into this swiper yet.
            const swiperSlideCount = swiperInstance.slides.length;
            const mediaGalleryCount = window.ironman.postMediaGallery['root'].length;
            if(swiperSlideCount < mediaGalleryCount) {
                // There are more items in the global post media gallery that weren't loaded into this swiper yet.
                // Add them to the swiper and return.
                
                // Get the swiper item template.
                const swiperItemTemplate = getTemplate('directoryRootSwiperItemTemplate');

                // Slice new items from the global post media gallery.
                const newItems = window.ironman.postMediaGallery['root'].slice(swiperSlideCount);

                // Add media index (start from initial offset) to each media item so it opens the correct image in lightgallery.
                newItems.forEach((media, index) => {
                    media.media_index = swiperSlideCount + index;
                });

                // Get the new items and add them to the swiper instance.
                const newSlides = getSwiperMediaItems(newItems, swiperItemTemplate);
                swiperInstance.appendSlide(newSlides);
                return;
            }

            // Otherwise, check that there are remaining slides to fetch from the server. (Compare total items from count array to what we have loaded)
            const total = window.ironman.postMediaGalleryCounts['root'] || 0;
            if(total <= swiperSlideCount) {
                log('directoryRootMediaGallery_swiperInstance: No remaining slides to fetch for root media gallery');
                return;
            }

            // Check if a fetch more request is already in flight
            if(directoryRootMediaGallery_inflightFetchMoreRequest) {
                log('directoryRootMediaGallery_swiperInstance: Fetch more items already in flight');
                return;
            }

            // Set the inflight fetch more request flag to true.
            directoryRootMediaGallery_inflightFetchMoreRequest = true;

            log('directoryRootMediaGallery_swiperInstance: Fetching more items');

            // Fetch next page of media items for the root media gallery and add it to the swiper instances.
            const data = {
                post_id: window.ironman.postId,
                child_id: null,
                offset: window.ironman.postMediaGallery['root'].length,
                limit: 20,
            };

            callAdminAjax('querySinglePostMediaGallery', data, 'querySinglePostMediaGallery', {
                onSuccess: (response) => {
                    if(response.success === true && typeof response.data.query_results === 'object' && response.data.query_results.length > 0) {
                        log('Post media gallery downloaded successfully.');

                        const startingOffset = window.ironman.postMediaGallery['root'].length;

                        // Add the new items to the window.ironman.postMediaGallery['root'].
                        // window.ironman.postMediaGallery['root'] = [...window.ironman.postMediaGallery['root'], ...response.data.query_results];
                        window.ironman.postMediaGallery['root'] = window.ironman.postMediaGallery['root'].concat(response.data.query_results);

                        // Dedupe in case the order switched between fetches
                        window.ironman.postMediaGallery['root'] = window.ironman.postMediaGallery['root'].filter((media, index, self) =>
                            index === self.findIndex((t) => t.id === media.id)
                        );
        
                        // Get the swiper item template.
                        const swiperItemTemplate = getTemplate('directoryRootSwiperItemTemplate');

                        // Add media index (start from initial offset) to each media item so it opens the correct image in lightgallery.
                        response.data.query_results.forEach((media, index) => {
                            media.media_index = startingOffset + index;
                        });

                        // Add the new items to the swiper instance.
                        const newItems = getSwiperMediaItems(response.data.query_results, swiperItemTemplate);
                        swiperInstance.appendSlide(newItems);
        
                    } else {
                        log('error getting post media gallery items.');
                    }
                },
                onFail: (error) => {
                    log('error getting post media gallery.');
                },
                onComplete: (response) => {
                    // No longer inflight, as the request is complete.
                    directoryRootMediaGallery_inflightFetchMoreRequest = false;
                }
            }, 'non-blocking', 'Downloading more media items...');
        }
    });
}
